import {ChangeDetectionStrategy, Component, inject, Input, OnInit} from '@angular/core';
import {
  BaseComponent,
  CartProduct,
  ProductCustomer,
  ProductPackResponse,
  StoreService
} from 'compob2b-libs'
import { AsyncPipe, DecimalPipe, NgClass, NgForOf, NgIf } from '@angular/common'
import {NbSecurityModule} from '@nebular/security'
import {NbButtonModule, NbCardModule, NbIconModule, NbPopoverModule, NbSpinnerModule, NbTooltipModule} from '@nebular/theme'
import {ProductService} from '../../services/product.service'
import {catchError, map, take} from 'rxjs/operators'
import {Observable} from 'rxjs'

@Component({
  selector: 'app-product-availability',
  imports: [
    NgIf,
    NbSecurityModule,
    NbTooltipModule,
    NbIconModule,
    NgClass,
    NbSpinnerModule,
    NbCardModule,
    NgForOf,
    NbButtonModule,
    NbPopoverModule,
    AsyncPipe,
    DecimalPipe,

  ],
  templateUrl: './product-availability.component.html',
  styleUrl: './../product-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductAvailabilityComponent extends BaseComponent implements OnInit {
  @Input() product: ProductCustomer | CartProduct
  @Input() showDetails = false;

  productService = inject(ProductService);
  storeService = inject(StoreService);
  multiplicityOrder = 1;
  packs$: Observable<ProductPackResponse>;

  get unitHeader(): string {
    return this.product?.unitHeader?.replace(/\.+$/, "");
  }

  ngOnInit() {
    this.loading = true;

    if (this.showDetails) {
      this.packs$ = this.compoApiService.get<ProductPackResponse>('/product/pack/' + this.product.id + '/' + this.productService.customerGroup?.id)
        .pipe(
          take(1),
          catchError(err => this.handleError(err, true)),
          map(response => {
            this.loading = false;
            return response.data;
          })
        );

      let multiplicity = this.product.multiplicityOrder;

      if (multiplicity > 0) {
        this.multiplicityOrder = multiplicity;
      }
    }
  }
}
